import React, { useEffect, useState } from 'react';
import { DataVendor, DjangoListResponse, ItemList } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import MultiFilterDropdown, { SelectOption } from './MultiFilterDropdown';
import { CurrentStateFilterContext } from 'v2/context/currentStateFilterContext';

export interface MultiSelectDataVendorsProps {
  onChange?: (option: ItemList | undefined) => void;
  defaultValues: ItemList;
  disabled?: boolean;
  containFiles: boolean;
  clearAll?: boolean;
  className?: string;
}

export const initalState = { is_all: false, list: [] };

function MultiSelectDataVendors({
  onChange,
  defaultValues,
  disabled = false,
  containFiles,
  clearAll = true,
  className,
}: MultiSelectDataVendorsProps) {
  const [defaultOptions, setDefaultOptions] = useState<
    SelectOption<DataVendor>[]
  >([]);
  const [currentState, setCurrentState] = useState(
    defaultValues?.is_all ? initalState : defaultValues
  );

  useEffect(() => {
    loadOptions('', (options) => {
      if (defaultValues) {
        if (defaultValues.is_all) {
          onChange?.({
            is_all: true,
            list: options.map((o) => o.value),
          });
        } else {
          const defaultDataVendors = {
            is_all: false,
            list: options
              .map((o) => o.value as DataVendor)
              .filter((dv) =>
                defaultValues.list.find((dave) => dave.id === dv.id)
              ),
          };
          setCurrentState(defaultDataVendors);
          onChange?.(defaultDataVendors);
        }
      }
    });
  }, []);

  useEffect(() => {
    loadOptions('', (options) => {
      setDefaultOptions(options);
    });
  }, [defaultValues, containFiles, clearAll]);

  const loadOptions = async (
    inputValue: string,
    callback: (options: SelectOption<DataVendor>[]) => void
  ) => {
    const params = {
      contain_files: containFiles ? true : undefined,
      search_text: inputValue || undefined,
      size: !inputValue ? 500 : undefined,
    };

    try {
      const data = await restFactory.get<DjangoListResponse<DataVendor>>(
        `/dj/api/v1/data_vendor/`,
        params
      );
      const options: SelectOption<DataVendor>[] = data.results.map(
        (datavendor) => ({
          label: datavendor.name,
          value: datavendor,
        })
      );
      callback(options);
    } catch (error) {
      callback([]);
    }
  };

  return (
    <CurrentStateFilterContext.Provider
      value={{
        setCurrentState,
        currentState,
      }}
    >
      <MultiFilterDropdown
        id="allCompanies"
        placeHolder="All Companies"
        loadOptions={loadOptions}
        onChange={(option: ItemList) => {
          const data: ItemList = clearAll
            ? option
            : {
                ...option,
                list: option.is_all
                  ? defaultOptions.map((o) => o.value)
                  : option.list,
              };
          onChange?.(data);
        }}
        secondaryPlaceHolder="Select Companies"
        defaultOptions={defaultOptions}
        disabled={disabled}
        noOptionsMessage="No Companies"
        className={className}
      />
    </CurrentStateFilterContext.Provider>
  );
}

export default MultiSelectDataVendors;
